import React from "react";
import TabSelector from "globalComponents/TabSelector/TabSelector";

export default function ColorTypeSelector({
  itemDay,
  colorType,
  setColorType,
}) {
  const day = itemDay.getDate();
  const white = (
    <div className="graphic-calendar-note-example">
      {day}
      <div className="flex-center-div">
        <div className="graphic-calendar-note white" />
      </div>
    </div>
  );
  const red = <div className="graphic-calendar-note-example red">{day}</div>;
  const green = (
    <div className="graphic-calendar-note-example">
      {day}
      <div className="graphic-calendar-note example green" />
    </div>
  );
  const optionContents = [white, red, green];
  return (
    <div className="type-selector-container">
      <TabSelector
        optionContents={optionContents}
        shape="round"
        options={["white", "red", "green"]}
        selectedOption={colorType}
        setSelectedOption={setColorType}
      />
    </div>
  );
}
